import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type BriefSet from "./BriefSet";
import type OrganisationTeam from "./OrganisationTeam";

@Model()
class BriefSetsOrganisationTeam extends ApplicationRecord {
  static jsonapiType = "brief_sets_organisation_teams";

  @BelongsTo() briefSet: BriefSet;

  @Attr() briefSetId: number;

  @BelongsTo() organisationTeam: OrganisationTeam;

  @Attr() organisationTeamId: number;
}

export default BriefSetsOrganisationTeam;
